import React from 'react'
import { Grid, Card, CardContent, Skeleton } from '@mui/material'

export interface CatalogGridSkeletonProps {
  /** Number of grid card items to render. Default: 6 */
  count?: number
}

export const CatalogGridSkeleton: React.FC<CatalogGridSkeletonProps> = ({ count = 6 }) => {
  return (
    <Grid container spacing={3}>
      {Array.from({ length: count }).map((_, index) => (
        <Grid item xs={12} sm={6} md={4} key={index}>
          <Card sx={{ borderRadius: 3, overflow: 'hidden' }}>
            <Skeleton variant="rectangular" height={160} />
            <CardContent sx={{ p: 2 }}>
              <Skeleton variant="text" width="75%" height={24} sx={{ mb: 1 }} />
              <Skeleton variant="text" width="45%" height={18} />
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  )
}

export default CatalogGridSkeleton
